module.exports = __webpack_public_path__ + "static/media/online-image-01.abf46893.png";